import { render } from "./RfpCategories.vue?vue&type=template&id=198eb1e0&scoped=true&ts=true"
import script from "./RfpCategories.vue?vue&type=script&lang=ts"
export * from "./RfpCategories.vue?vue&type=script&lang=ts"

import "./RfpCategories.vue?vue&type=style&index=0&id=198eb1e0&scoped=true&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198eb1e0"]])

export default __exports__